import { Component} from '@angular/core';
import { FormControl } from '@angular/forms';
import { DocumentReader } from 'src/app/modules/core/store/models';

@Component({
  selector: 'app-phone-cell',
  templateUrl: './phone-cell.component.html',
  styleUrls: ['./phone-cell.component.scss'],
  standalone: false
})
export class PhoneCellComponent {
  value: any;

  control = new FormControl({ value: '', disabled: true });

  agInit(params: any): void {
    const document = params.data;
    const field = params.schemaField;
    const reader = new DocumentReader(document);

    this.value = !!params.data ? reader.getFieldValue(field.systemName) : params.value;

    this.control.patchValue(this.value);
  }
}
